// eslint-disable-next-line no-shadow
export enum LinksAppEnum {
  PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.cincoapp&pcampaignid=web_share',
  APPLE_STORE = 'https://apps.apple.com/app/id1586371435',
}
